// eslint-disable-next-line @typescript-eslint/no-restricted-imports
import { TextField, TextFieldProps } from '@material-ui/core';

export const withoutAutoFill = (Component: typeof TextField) => {
  const WrapperComponent = (props: TextFieldProps) => {
    const { inputProps, ...rest } = props;

    return (
      <Component
        autoComplete="off"
        inputProps={{
          ...inputProps,
          'data-lpignore': 'true',
          'data-form-type': 'other',
        }}
        {...rest}
      />
    );
  };

  return WrapperComponent;
};
